import config from '../config/config';
import { getLanguage, getUserInfo } from './localStorage';
import { getCurrentResource, parseHexString } from './tools';
import { 
	ACTION_CLASSIFIER_IMPORT,
	ACTION_PROVIDER_IMPORT,
	ACTION_USH_EXPORT,
	ACTION_USH_IMPORT,

	ACTION_BOOK_EXPORT,
	ACTION_BOOK_IMPORT,
	ACTION_CREATE_REQUEST_BY_ORDERS,
	ACTION_EBOOK_BANK_IMPORT,
	ACTION_EBOOK_PAYMENT_IMPORT,
	ACTION_EBOOK_PAYMENT_DOWNLOAD,
	ACTION_EBOOK_REPORT_EXPORT,
	ACTION_EBOOK_SUPPLIER_EXPORT,
	ACTION_EBOOK_SUPPLIER_UPLOAD,
	ACTION_ONIX_EXPORT,
	ACTION_ONIX_IMPORT,
	ACTION_ONIX_IMPORT_LOCAL,
	ACTION_ONIX_IMPORT_ELIBRI,
	ACTION_ORDER_CREATE_BY_OFFER,
	ACTION_ORDERS_CREATE_BY_OFFERS,
	ACTION_PROCUREMENT_CREATE_BY_OFFER,
	ACTION_PRODUCT_BORROW_BOOK,
	ACTION_ELIBRI_API
} from './consts/actions';

export const LOGIN_API_URL = 'security/userinfo';
export const GETUSERINFO_API_URL = 'security/getuserinfo';
export const USER_PROFILE_API_URL = 'security/userprofile';
export const CHANGE_PASSWORD_API_URL = 'security/changepassword';

export const REALM_GET_HASH_API_URL = 'realm/gethash';
export const REALM_GET_REALM_API_URL = 'realm/getrealm';

export const DBMANAGER_API_URL = 'dbmanager/update';
export const DBMANAGER_UPDATE_API_URL = 'dbmanager/start_update';
export const DBMANAGER_GET_UPDATE_INFO_API_URL = 'dbmanager/getupdateinfo';
export const DBMANAGER_GET_DB_ACCESS_API_URL = 'dbmanager/getdbaccess';
export const DBMANAGER_SET_DB_ACCESS_API_URL = 'dbmanager/setdbaccess';
export const OPTIONS_GET_API_URL = 'options/get';
export const OPTIONS_SAVE_API_URL = 'options/save';
export const SYSINFO_GET_API_URL = 'sysinfo/get';

export const QUERY_GETFORM_API_URL = 'query/getform'; 
export const QUERY_GETPAGE_API_URL = 'query/getpage'; 
export const QUERY_GETENTITYFORM_API_URL = 'query/getentityform'; 
export const QUERY_GETENTITYPAGE_API_URL = 'query/getentitypage'; 
export const QUERY_GETCLASSIFIERS_API_URL = 'query/getclassifiers'; 
export const QUERY_LOADGROUPSANDUSERS_API_URL = 'query/loadgroupsandusers'; 

export const PROGRESS_INFO_API_URL = 'progress/info'; 
export const PROGRESS_BREAK_API_URL = 'progress/break';
export const PROGRESS_CLOSE_API_URL = 'progress/close'; 

export const TREE_POPULATEROOTS_API_URL = 'tree/populateroots'; 
export const TREE_POPULATENODE_API_URL = 'tree/populatenode'; 
export const TREE_POPULATEBUNDLE_API_URL = 'tree/populatebundle'; 

export const PROFILE_GET_API_URL = `profile/get`;
export const PROFILE_SAVE_API_URL = `profile/save`;
export const PROFILE_SAVE_BUNDLE_API_URL = 'profile/saveBundle';
export const PROFILE_DELETE_API_URL = `profile/delete`;

export const MASTER_LOAD_REF_API_URL = 'master/loadref';
export const MASTER_LOAD_REF_LIST_API_URL = 'master/loadreflist';
export const MASTER_LOAD_OBJECT_API_URL = 'master/loadobject';
export const MASTER_LOAD_LIST_API_URL = 'master/loadlist';

export const REFLIST_IS_ACTUAL_API_URL = 'entity/reflist/is_actual';
export const REFLIST_LOAD_API_URL = 'entity/reflist/load';

export const ENTITY_LOAD_BODY_API_URL = 'entity/load_body';
export const ENTITY_LOAD_LIST_API_URL = 'entity/load_list';
export const ENTITY_LOAD_API_URL = 'entity/load';
export const ENTITY_LOAD_PLAIN_API_URL = 'entity/loadplain';
export const ENTITY_EMAIL_LIST_API_URL = 'entity/email_list';
export const ENTITY_SAVE_API_URL = 'entity/save';
export const ENTITY_CHANGE_OWNER_API_URL = 'entity/change_owner';
export const ENTITY_MERGE_API_URL = 'entity/merge';
export const ENTITY_UPDATE_FIELD_API_URL = 'entity/update_field';
export const ENTITY_UPDATE_GLOBAL_ID_API_URL = 'entity/update_global_id';
export const ENTITY_GENERATE_GLOBAL_ID_API_URL = 'entity/generate_global_id';
export const ENTITY_DELETE_API_URL = 'entity/delete';

export const CACHE_GET_STRING_API_URL = 'cache/getstring';
export const CACHE_PUT_STRING_API_URL = 'cache/putstring';

export const PLAIN_INIT_API_URL = 'plain/init'; 

export const KATOTTG_GETRECORD_API_URL = 'katottg/getrecord';
export const KATOTTG_SAVERECORD_API_URL = 'katottg/saverecord';
export const KATOTTG_GETCHILDREN_API_URL = 'katottg/children';
export const KATOTTG_GETPATH_API_URL = 'katottg/path';
export const KATOTTG_IMPORT_API_URL = 'katottg/import';

export const ACTION_AUTHORITY_AUTHOR_EXPORT_API_URL = 'action/aa/export';
export const ACTION_AUTHORITY_PUBLISHER_EXPORT_API_URL = 'action/ap/export';
export const ACTION_BOOK_EXPORT_API_URL = 'action/book/export';
export const ACTION_BOOK_IMPORT_API_URL = 'action/book/import';
export const ACTION_BOOKEXPORT_API_URL = 'action/' + ACTION_BOOK_EXPORT; 
export const ACTION_BOOKIMPORT_API_URL = 'action/' + ACTION_BOOK_IMPORT; 
export const ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_API_URL = 'action/bookshop/get_provider_bookshops';
export const ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_FULL_API_URL = 'action/bookshop/get_provider_bookshops_full';
export const ACTION_BOOKSHOP_GET_PROVIDER_MERCHANT_API_URL = 'action/bookshop/get_provider_merchants';
export const ACTION_BOOKSHOP_GET_PROVIDER_TERMINAL_API_URL = 'action/bookshop/get_provider_terminals';
export const ACTION_CLASSIFIER_IMPORT_API_URL = 'action/' + ACTION_CLASSIFIER_IMPORT;
export const ACTION_CLASSIFIERIMPORT_API_URL = 'action/' + ACTION_CLASSIFIER_IMPORT; 
export const ACTION_CREATE_REQUEST_BY_ORDERS_API_URL = 'action/' + ACTION_CREATE_REQUEST_BY_ORDERS;
export const ACTION_CREATE_WORKS_BY_BOOKS_API_URL = 'action/book/create_works';
export const ACTION_EBOOK_BANK_IMPORT_API_URL = 'action/' + ACTION_EBOOK_BANK_IMPORT;
export const ACTION_EBOOK_MERCHANT_LOAD_API_URL = 'action/merchant/load';
export const ACTION_EBOOK_MERCHANT_LOAD_LIST_API_URL = 'action/merchant/load_list';
export const ACTION_EBOOK_MERCHANT_LOAD_ALL_API_URL = 'action/merchant/loadall';
export const ACTION_EBOOK_PAYMENT_IMPORT_API_URL = 'action/' + ACTION_EBOOK_PAYMENT_IMPORT;
export const ACTION_EBOOK_PAYMENT_DOWNLOAD_API_URL = 'action/' + ACTION_EBOOK_PAYMENT_DOWNLOAD;
export const ACTION_EBOOK_REPORT_CHECK_API_URL = 'action/ebook/report/check';
export const ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL = 'action/ebook/report/getsupplier';
export const ACTION_EBOOK_REPORT_EXPORT_API_URL = 'action/' + ACTION_EBOOK_REPORT_EXPORT;
export const ACTION_EBOOK_REPORT_IMPORT_API_URL = 'action/ebook_report_import';
export const ACTION_EBOOK_REPORT_IMPORT_LOCAL_API_URL = 'action/ebook_report_import_local';
export const ACTION_EBOOK_REPORT_ITEM_SAVE_API_URL = 'action/ebook/report/save_item';
export const ACTION_EBOOK_REPORT_DELETE_ITEMS_API_URL = 'action/ebook/report/delete_items';
export const ACTION_EBOOK_SUPPLIER_EXPORT_API_URL = 'action/' + ACTION_EBOOK_SUPPLIER_EXPORT;
export const ACTION_EBOOK_SUPPLIER_UPLOAD_API_URL = 'action/' + ACTION_EBOOK_SUPPLIER_UPLOAD;
export const ACTION_EBOOK_SUPPLIER_UPLOAD_WL_LOCAL_FILE_API_URL = 'action/ebookswl/localfile';
export const ACTION_EBOOK_SUPPLIER_UPLOAD_WL_SERVER_FILE_API_URL = 'action/ebookswl/serverfile';
export const ACTION_EBOOK_SUPPLIER_GET_FOR_REPORT_API_URL = 'action/ebookswl/ebook_supplier_get_for_report';
export const ACTION_EBOOK_SUPPLIER_GET_MERCHANTS_API_URL = 'action/ebookswl/ebook_supplier_get_merchants';
export const ACTION_EBOOK_SUPPLIER_GET_TERMINALS_API_URL = 'action/ebookswl/ebook_supplier_get_terminals';
export const ACTION_ELIBRI_API_URL = 'action/' + ACTION_ELIBRI_API;
export const ACTION_MREPORT_IMPORT_API_URL = 'action/mreport_import';
export const ACTION_MREPORT_IMPORT_LOCAL_API_URL = 'action/mreport_import_local';
export const ACTION_MREPORT_ITEM_SAVE_API_URL = 'action/mreport/save_item';
export const ACTION_MREPORT_ITEM_DELETE_API_URL = 'action/mreport/delete_items';
export const ACTION_ONIXEXPORT_API_URL = 'action/' + ACTION_ONIX_EXPORT; 
export const ACTION_ONIXIMPORT_API_URL = 'action/' + ACTION_ONIX_IMPORT; 
export const ACTION_ONIXIMPORT_LOCAL_API_URL = 'action/' + ACTION_ONIX_IMPORT_LOCAL; 
export const ACTION_ONIXIMPORT_ELIBRI_API_URL = 'action/' + ACTION_ONIX_IMPORT_ELIBRI; 
export const ACTION_ORDER_CREATEBYOFFER_API_URL = 'action/' + ACTION_ORDER_CREATE_BY_OFFER; 
export const ACTION_ORDERS_CREATEBYOFFERS_API_URL = 'action/' + ACTION_ORDERS_CREATE_BY_OFFERS; 
export const ACTION_PROCUREMENT_CREATEBYOFFER_API_URL = 'action/' + ACTION_PROCUREMENT_CREATE_BY_OFFER; 
export const ACTION_PRODUCT_EXPORT_API_URL = 'action/product/export';
export const ACTION_PRODUCT_BORROW_BOOK_API_URL = 'action/product/' + ACTION_PRODUCT_BORROW_BOOK;
export const ACTION_PROVIDER_IMPORT_API_URL = 'action/' + ACTION_PROVIDER_IMPORT; 
export const ACTION_PROVIDER_LOAD_AGGREGATOR_LIST_API_URL = 'action/provider/load_aggregator_list'; 
export const ACTION_ROLE_IMPORT_API_URL = 'action/role/import';
export const ACTION_SEND_REQUEST_BY_EMAIL_API_URL = 'action/request/sendemail';
export const ACTION_USH_EXPORT_API_URL = 'action/' + ACTION_USH_EXPORT;
export const ACTION_USH_IMPORT_API_URL = 'action/' + ACTION_USH_IMPORT;
export const ACTION_USH_IMPORT_LOCAL_API_URL = 'action/ush_import_local';
export const ACTION_YOUCONTROL_GET_PERSON_INFO_LOCAL_API_URL = 'action/youscore/personinfo';
export const ACTION_YOUCONTROL_GET_EMLOYEE_QTY_LOCAL_API_URL = 'action/youscore/emplqty';

export const SAVE_TEMP_IMAGE_API_URL = 'image/savetemporary';

export const CONVERTER_API_URL = 'converter/knr';

export const getRequestProperties = (url) => {
	var authorization = '';
	var userInfo = getUserInfo();
	if( userInfo.jwt ) {
		authorization = 'Bearer ' + userInfo.jwt;
	}

	var realUrl = config.apiGateway.URL;
	if( config.apiGateway.BASE_PATH )
		realUrl += '/' + config.apiGateway.BASE_PATH;
	realUrl += '/' + url;

	var properties = {
		authorization: authorization,
		language: getLanguage(),
		url: realUrl
	}
	
	return properties;
}

export const performApiRequest = async (url, requestBody) => {
	url = getApiUrl(url);
	const request = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json', 
			'Accept-Language': getLanguage() 
		},
		body: JSON.stringify( requestBody )
	};
	let userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	console.log( "performApiRequest", url, request );
	let response = null;
	try {
		response = await fetch(url, request);
	} catch(err) {
		console.log("Error", err);
		let res = getCurrentResource();
		response = {success: false, message: res.util.restapi.msgNetworkError}
		console.log(response);
		return response;
	}	
	response = await response.json();
	console.log( response );
	return response;
}

export const performApiRequestForm = async (url, form) => {
	url = getApiUrl(url);
	const request = {
		method: 'POST',
		headers: { 'Accept-Language': getLanguage() },
		body: form,
	};
	let userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	console.log( request );
	let response = await fetch(url, request);
	response = await response.json();
	console.log( response );	
	return response;
}

export const performApiDownloadRequest = async (url, requestBody, blobType) => {
	url = getApiUrl(url);
	const request = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json', 
			'Accept-Language': getLanguage() 
		},
		body: JSON.stringify( requestBody )
	};
	let userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	console.log( "performApiRequest", url, request );
	let response;
	try {
		response = await fetch(url, request);
		if( response.ok ) {
			let blob = await response.blob();
			blob = new Blob([blob], { type: blobType })
			response = {success: true, blob: blob};
		} else {
			
			response = {
				success: false, 
				message: parseHexString(response.headers.get('message')),
				log: parseHexString( response.headers.get('log') )
			};
		}
		console.log( "Response", url, response );
		return response;
	} catch(err) {
		console.log("Error", err);
		let res = getCurrentResource();
		response = {success: false, message: res.util.restapi.msgNetworkError}
		return response;
	}
}

export const getApiUrl = ( url ) => {
	let fullUrl = config.apiGateway.URL;
	if( config.apiGateway.BASE_PATH )
		fullUrl += '/' + config.apiGateway.BASE_PATH;
	fullUrl += '/' + url;
	return fullUrl;
}

// -------------------------------------------------------------------------------------------------
export const performExportRequest = async (exportOptions, urlExportAction) => {

	var url = config.apiGateway.URL;
	if( config.apiGateway.BASE_PATH )
		url += '/' + config.apiGateway.BASE_PATH;
	url += '/' + urlExportAction;

	const request = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json', 
			'Accept-Language': getLanguage() 
		},
		body: JSON.stringify( exportOptions )
	};
	var userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	console.log( request );
	var response = await fetch(url, request);
	if( ! response.ok ) {
		console.log( response );		
		if( response.status == 500) {
			var jsonBody = await response.json();
			response = {ok: false, message: jsonBody.message};
		} else {
			response = {ok: false, message: "HTTP error"};
		}
	}	
	
	return response;
}

export const performImportRequest = async (url, form) => {
	url = getApiUrl(url);
	const request = {
		method: 'POST',
		body: form,
		headers: { 'Accept-Language': getLanguage() }
	};
	var userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	console.log( request );
	var response = await fetch(url, request);
	if( response.ok ) {
		response = await response.json();
	} else {
		response = {success: false, message: 'HTTP error ' + response.status}
	}	
	return response;
}


export const performApiGetRequest = async (url) => {
	url = getApiUrl(url);
	return performApiGetRequestFinalUrl( url );
}

export const performApiGetRequestFinalUrl = async (url) => {
	const request = {
		method: 'GET',
		headers: { 
			'Content-Type': 'application/json', 
			'Accept-Language': getLanguage() 
		}
	};
	var userInfo = getUserInfo();
	if( userInfo.jwt ) {
		request.headers.Authorization = 'Bearer ' + userInfo.jwt;
	}
	var response = await fetch(url, request);
	response = await response.json();
	return response;
}


